import axiosInstance from "../../../api/axiosConfig";

export const getCustomerCartList = (params: any) => {
  return axiosInstance.get("/admin/customer-cart-list", {
    params: params,
  });
};
